<template>
  <div>
    <el-tabs v-model="activePane" @tab-click="onTabChange">
      <el-tab-pane label="Published" name="A"></el-tab-pane>
      <el-tab-pane label="Others" name="P"></el-tab-pane>
    </el-tabs>
    <div class="card shadow">
      <div class="card-header">
        <div class="row align-items-center">
          <div class="col-6">
            Ingredients
          </div>
          <div class="col-6">
            <ingredient-create v-if="$store.getters.isAdmin || $store.getters.isMod" />
          </div>
        </div>
      </div>
      <div v-loading="loading">
        <table class="table">
          <thead class="thead-light">
            <tr>
              <th>Name</th>
              <th>Created</th>
              <th v-if="$store.getters.isAdmin || $store.getters.isMod">Operations</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="ingredient in ingredients" :key="ingredient.id">
              <td>
                <router-link :to="{ name: 'ingredients-id', params: { id: ingredient.id } }">
                  {{ ingredient.title }}
                </router-link>
                <span v-if="ingredient.desc && ingredient.status === 'P'" class="badge badge-warning">In Progress</span>
                <div>{{ ingredient.substitutes }}</div>
              </td>
              <td>
                {{ ingredient.createdAt }}
                <span v-if="ingredient.isNew" class="badge badge-success">New</span>
              </td>
              <td>
                <ingredient-view v-if="ingredient.status === 'A'" :slug="ingredient.slug" />
                <ingredient-publish v-else :ingredientId="ingredient.id" @update="getIngredients" />
                <ingredient-delete :ingredientId="ingredient.id" @delete="getIngredients" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import IngredientCreate from '@/components/Ingredient/IngredientCreate'
import IngredientView from '@/components/Ingredient/IngredientView'
import IngredientPublish from '@/components/Ingredient/IngredientPublish'
import IngredientDelete from '@/components/Ingredient/IngredientDelete'

export default {
  data() {
    return {
      loading: true,
      activePane: 'A',
      ingredients: [],
    }
  },

  components: {
    IngredientCreate,
    IngredientView,
    IngredientPublish,
    IngredientDelete,
  },

  mounted() {
    this.getIngredients(this.activePane)
  },

  methods: {
    onTabChange(tab, event) {
      this.activePane = tab.name
      this.getIngredients(tab.name)
    },

    async getIngredients(status) {
      try {
        var { data } = await this.$http.get(`/ingredients`, {
          params: {
            status: this.activePane,
            limit: 512,
          },
        })
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }

      var oneWeekAgo = moment(new Date()).subtract(1, 'week')

      this.ingredients = data.map(item => {
        item.substitutes = item.substitutes.join(', ')
        item.isNew = new Date(item.createdAt) >= oneWeekAgo
        item.createdAt = moment(item.createdAt).fromNow()
        return item
      })
    },
  },
}
</script>
